/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { Window as C, WindowActionsBar as w } from "@progress/kendo-react-dialogs";
import { Button as v } from "@progress/kendo-react-buttons";
import { Input as y, Checkbox as L } from "@progress/kendo-react-inputs";
import { Form as b, FormElement as x, FieldWrapper as s } from "@progress/kendo-react-form";
import { applyLink as F, getMark as N } from "@progress/kendo-editor-common";
import { provideLocalizationService as z, registerForLocalization as H } from "@progress/kendo-react-intl";
import { messages as l } from "../messages/index.mjs";
let I = class extends e.Component {
  constructor() {
    super(...arguments), this.href = null, this.title = null, this.target = null, this.onClose = () => {
      this.props.view.focus(), this.props.onClose();
    }, this.onInsert = () => {
      const t = this.props.view, n = this.props.settings.mark, a = {
        href: this.href ? this.href.value : void 0,
        title: this.title ? this.title.value : void 0,
        target: this.target && this.target.element && this.target.element.checked ? "_blank" : void 0
      };
      F({ mark: n, attrs: a }, this.props.settings.commandName)(t.state, t.dispatch), this.onClose();
    };
  }
  /**
   * @hidden
   */
  render() {
    const { view: t, settings: n, dir: a, render: m } = this.props, i = z(this), {
      insertHyperlinkDialogTitle: c,
      insertHyperlinkAddress: h,
      insertHyperlinkTitle: k,
      insertHyperlinkNewWindow: d,
      insertHyperlinkCancel: g,
      insertHyperlinkInsert: p
    } = n.messages, r = t ? N(t.state, t.state.schema.marks[n.mark]) : !1, u = /* @__PURE__ */ e.createElement(
      b,
      {
        render: () => /* @__PURE__ */ e.createElement(x, { horizontal: !0 }, /* @__PURE__ */ e.createElement(s, null, /* @__PURE__ */ e.createElement("label", { htmlFor: "k-editor-link-url", className: "k-form-label" }, i.toLanguageString(h, l[h])), /* @__PURE__ */ e.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ e.createElement(
          y,
          {
            type: "text",
            id: "k-editor-link-url",
            ref: (o) => this.href = o,
            defaultValue: r && r.attrs.href || void 0,
            autoFocus: !0
          }
        ))), /* @__PURE__ */ e.createElement(s, null, /* @__PURE__ */ e.createElement("label", { htmlFor: "k-editor-link-text", className: "k-form-label" }, i.toLanguageString(k, l[k])), /* @__PURE__ */ e.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ e.createElement(
          y,
          {
            type: "text",
            id: "k-editor-link-text",
            ref: (o) => this.title = o,
            defaultValue: r && r.attrs.title || void 0
          }
        ))), n.linkTarget !== !1 && /* @__PURE__ */ e.createElement(s, null, /* @__PURE__ */ e.createElement("label", { htmlFor: "k-editor-link-target", className: "k-checkbox-label" }, /* @__PURE__ */ e.createElement(
          L,
          {
            id: "k-editor-link-target",
            ref: (o) => this.target = o,
            defaultChecked: r && !!r.attrs.target || void 0
          }
        ), i.toLanguageString(d, l[d]))))
      }
    ), f = [
      /* @__PURE__ */ e.createElement(v, { onClick: this.onClose, dir: a, key: "cancel" }, i.toLanguageString(g, l[g])),
      /* @__PURE__ */ e.createElement(v, { onClick: this.onInsert, themeColor: "primary", dir: a, key: "insert" }, i.toLanguageString(p, l[p]))
    ], E = /* @__PURE__ */ e.createElement(
      C,
      {
        initialWidth: 450,
        initialHeight: 250,
        className: "k-editor-window",
        title: i.toLanguageString(c, l[c]),
        onClose: this.onClose,
        style: a === "rtl" ? { textAlign: "right" } : void 0,
        modal: !0,
        minimizeButton: () => null,
        maximizeButton: () => null,
        resizable: !1
      },
      u,
      /* @__PURE__ */ e.createElement(w, null, ...f)
    );
    return m ? m(E, { content: u, actionButtons: f }) : E;
  }
};
H(I);
export {
  I as InsertLinkDialog
};
